<template>
  <div v-show="isShowBanner" id="sticky-banner">
    <div v-html="replaceHTMLSellerInfo(bannerContent)"></div>
    <button class="banner-close" @click="closeBanner()">
      <i class="fa fa-times-circle" aria-hidden="true"></i>
    </button>
  </div>
</template>

<script>
import { replaceHTMLSellerInfo } from '@/common/utility'

export default {
  props: {
    bannerContent: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      isShowBanner: true
    }
  },
  methods: {
    replaceHTMLSellerInfo,
    closeBanner () {
      this.isShowBanner = false
    }
  }
}
</script>
<style scoped>
#sticky-banner {
  position: fixed;
  bottom: 20px;
  left: 20px;
  right: 20px;
  z-index: 1000;
  display: flex;
  align-items: center;
  width: max-content;
  margin: auto;
}

.banner-close {
  position: absolute;
  display: flex;
  justify-content: center;
  align-items: center;
  top: -10px;
  right: -5px;
  background: #fff;
  color: #a6a6a6;
  border: none;
  padding: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  cursor: pointer;
  font-size: 30px;
}

</style>



// WEBPACK FOOTER //
// src/view/productsNew/Banner.vue